import { useState } from 'react';

/**
 * Companion to useTablePaginationInit for sortable table headers.
 *
 * Clicking a NEW column sorts it ascending; clicking the column that is
 * already active flips its direction.
 *
 * The inline implementation this replaces flipped the direction on EVERY
 * click regardless of which column was clicked, which meant the first click
 * on any column sorted descending, and switching columns inherited an
 * unrelated direction from the previous one.
 *
 * Returns the same shape as useTablePaginationInit — a positional array — so
 * it reads consistently at the call site:
 *
 *   const [sort, sortDirection, handleSort] = useTableSortInit();
 */
const useTableSortInit = (
  defaultSort,
  defaultSortDirection
) => {
  const [sort, setSort] = useState(defaultSort || null);
  const [sortDirection, setSortDirection] = useState(defaultSortDirection || "asc");

  const handleSort = (value) => {
    if (sort === value) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSort(value);
      setSortDirection("asc");
    }
  };

  return [
    sort,
    sortDirection,
    handleSort
  ]
}

export default useTableSortInit;
